<div>
  <div *ngIf="isMultiImage" class="gallery-button-container">
    <button (click)="previousImage()" class="btn btn-clear gallery-button">&larr;    Prev</button>
    <button (click)="nextImage()" class="btn btn-clear gallery-button">Next    &rarr;</button>
  </div>
  <p *ngIf="isMultiImage" style="text-align: center; width: 100%">{{ currentPosition }}</p>
  <h2>{{ currentTitle }}</h2>

  <img *ngIf="mediaType == 'image'" [src]="currentUrl" alt="currentAltText"/>
  
  <div *ngIf="videoSource && mediaType == 'video'">
      <video #videoPlayerGallery controls *ngIf="videoSource.url"></video>
  </div>

  <p>{{ currentDescription }}</p>
</div>
